import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Verification, VerificationState } from '@scaliolabs/baza-web-verification-flow';
import { BazaNcBootstrapDto } from '@scaliolabs/baza-nc-shared';
import { LEGACY_NC_MODE_QUERY_PARAM } from '@scaliolabs/baza-web-utils';
import { BootstrapState } from '@scaliolabs/web/data-access';

@UntilDestroy()
@Component({
    selector: 'app-purchase-custom',
    templateUrl: './purchase-custom.component.html',
    styleUrls: ['./purchase-custom.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseCustomComponent {
    @Select(BootstrapState.initData)
    initData$: Observable<BazaNcBootstrapDto>;

    @Select(VerificationState.verification)
    verification$: Observable<Verification>;

    currentTab: number;
    dwollaSupport = true;

    constructor(private readonly route: ActivatedRoute) {
        this.route.data.pipe(untilDestroyed(this)).subscribe((params: Params) => {
            this.currentTab = Number(params.tab) || 0;
        });

        if (this.route.snapshot.queryParams?.mode == LEGACY_NC_MODE_QUERY_PARAM) {
            this.dwollaSupport = false;
        }
    }
}
